export const USUAL_GESTATION_DAYS = 280;
export const OVERDUE_WEEKS = 42;
